"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeoutText = exports.DIALOGUE_TITLE = exports.CONTINUE_BUTTON_TEXT = exports.LOGOUT_BUTTON_TEXT = void 0;
const react_1 = __importStar(require("react"));
const react_idle_timer_1 = require("react-idle-timer");
const DialogModal_1 = require("../../../components/DialogModal");
const MAX_IDLE_SECONDS = 60 * 28;
const COUNTDOWN_SECONDS = 120;
const ONE_SECOND_IN_MILLISECONDS = 1000;
exports.LOGOUT_BUTTON_TEXT = "Logout";
exports.CONTINUE_BUTTON_TEXT = "Continue";
exports.DIALOGUE_TITLE = "Session Timeout";
const getTimeoutText = (timeLeft) => `The current session will expire in ${timeLeft} second${timeLeft === 1 ? "" : "s"}. Would you like to continue the session?`;
exports.getTimeoutText = getTimeoutText;
const IdleTimeout = ({ idleSeconds = MAX_IDLE_SECONDS, countdownSeconds = COUNTDOWN_SECONDS, logout, }) => {
    const [isIdle, setIsIdle] = (0, react_1.useState)(false);
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const [timeLeft, setTimeLeft] = (0, react_1.useState)(countdownSeconds);
    (0, react_idle_timer_1.useIdleTimer)({
        timeout: ONE_SECOND_IN_MILLISECONDS * idleSeconds,
        debounce: 250,
        onIdle() {
            if (!isIdle) {
                setIsIdle(true);
                setTimeLeft(countdownSeconds);
                setIsModalOpen(true);
            }
        },
    });
    (0, react_1.useEffect)(() => {
        (async () => {
            if (timeLeft < 0)
                await logout();
            if (isIdle) {
                setTimeLeft(timeLeft - 1);
                await new Promise((resolve) => {
                    setTimeout(resolve, ONE_SECOND_IN_MILLISECONDS);
                });
            }
        })();
    }, [logout, timeLeft, isIdle]);
    return (react_1.default.createElement(DialogModal_1.DialogModal, { modalOpen: isModalOpen, modalType: "error", handleConfirm: () => {
            setTimeLeft(0);
            setIsModalOpen(false);
        }, handleClose: () => {
            setIsIdle(false);
            setTimeLeft(countdownSeconds);
            setIsModalOpen(false);
        }, title: exports.DIALOGUE_TITLE, text: (0, exports.getTimeoutText)(timeLeft), confirmButtonColor: "primary", confirmButtonLabel: exports.LOGOUT_BUTTON_TEXT, closeButtonColor: "secondary", closeButtonLabel: exports.CONTINUE_BUTTON_TEXT }));
};
exports.default = IdleTimeout;
